import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';
import {
  initPushNotifications,
  updatePushNotificationContext,
  unregisterPushToken,
} from '../services/pushNotifications';

export default function PushNotificationBridge() {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handlePushError = useCallback((message) => {
    if (!message) return;
    toast({
      title: 'Push notifications',
      description: message,
      variant: 'destructive',
    });
  }, [toast]);

  useEffect(() => {
    updatePushNotificationContext({ navigate, user: user ?? null, onError: handlePushError });
  }, [navigate, user, handlePushError]);

  useEffect(() => {
    if (!isAuthenticated || !user?.id) {
      return undefined;
    }

    initPushNotifications({ navigate, user, onError: handlePushError }).catch(() => {});

    return undefined;
  }, [isAuthenticated, user?.id, navigate, user, handlePushError]);

  useEffect(() => {
    if (isAuthenticated) return undefined;
    unregisterPushToken().catch(() => {});
    return undefined;
  }, [isAuthenticated]);

  return null;
}
